/**
* Side Scroller JS
* -----------------------------------------------------------------------------
*
* All the JS for the Side Scroller component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'side-scroller',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      $( '.side-scroller' ).each( function( key, val ) {
        window.scrollRefreshPriority--;
        if ( window.innerWidth > 1023 ) {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: val,
              pin: $( val ).find( '.inner-area' )[0],
              start: 'top top',
              end: '+=' + ( window.innerHeight * 2 ),
              pinSpacing: false,
              scrub: 0,
              // markers: true,
            },
          } );

          gsap.to( $( val ).find( '.inner-area' )[0], {
            x: () => -( $( val ).find( '.inner-area' )[0].scrollWidth - document.documentElement.clientWidth ) + 'px',
            ease: 'none',
            scrollTrigger: {
              trigger: val,
              invalidateOnRefresh: true,
              // pin: $( val ).find( '.inner-area' )[0],
              start: 'top top',
              scrub: 1,
              // pinSpacing: false,
              refreshPriority: window.scrollRefreshPriority,
              end: () => '+=' + $( val ).find( '.inner-area' )[0].offsetWidth,
            },
          } );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'side-scroller', COMPONENT );
} )( app );
